<template>
  <b-card class="contact-bcard">
    <div class="contact-card">
      <h5>Dúvidas? Fale com a gente:</h5>
      <p><a :href="whatsappLink" target="_blank" class="whatsapp-link"> Clique aqui para falar no WhatsApp</a></p>
      <p> <strong>Telefone:</strong> {{ phone }}</p>
      <p> <strong>E-mail:</strong>  <a :href="'mailto:' + email" class="email-link">{{ email }}</a></p>
    </div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
export default {
  name: "ContactCard",
  components: {BCard},
  props: {
    whatsappLink: {
      type: String,
      default: "https://wa.me/55552144"
    },
    phone: {
      type: String,
      default: "(11) 5555-2144"
    },
    email: {
      type: String,
      default: "atendimento@viainvest.com.br"
    }
  }
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
h1,h2,h3,h4,h5,h6,p, a {
  font-family: 'Poppins', sans-serif;
}

.contact-bcard {
  margin-left: 10px;
  width: 100%;
  max-width: 400px;
  border: none !important; 
  border-radius: 13px !important;
  background-color: #fff !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.25) !important;
  }
}

.contact-card h5 {
  margin-bottom: 15px;
}

.contact-card p {
  margin: 8px 0;
}

.contact-card a {
  text-decoration: none;
  color: #5457a7; 
}

.contact-card a:hover {
  text-decoration: underline;
}
</style>
